export default {install (Vue) 
{
    const Dominios = {
        obtenerDominioxDominioId (pDominioID) 
        {
            let vDominios = new dominioService(pAxios);
            var itemsDominios = [];
            vDominios.getByDominio(pDominioID).then(r => {
              for(let id in r.data) 
              {
                let dominio = {
                dominio_id: r.data[id].dominio_id,
                descripcion: ConvertirPrimeraLetraMayuscula(r.data[id].descripcion),
                }
                itemsDominios.push(dominio);
              }
            });
            return itemsDominios;
        }
      }
      Vue.prototype.$dominios = Dominios; 
}}